import React from "react";
import InputBox from "./InputBox";
import { resetpassword } from "../../utils/firebase/Firebase.utils";
import { useNavigate, Link } from "react-router-dom";
import { FaEnvelope, FaArrowLeft } from "react-icons/fa";
import toast from "react-hot-toast";
import { appName, unsplashBackground } from "../../utils/constants";

function ResetPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = React.useState("");
  const [isProcessing, setIsProcessing] = React.useState(false);

  const backgroundImage = unsplashBackground;

  const handleResetPassword = (e) => {
    e.preventDefault();
    setIsProcessing(true);

    const reset = async () => {
      try {
        const res = await resetpassword(email);

        if (res) {
          toast.success("Password reset link sent to your email");
          navigate("/login");
        } else {
          toast.error("Error: Please try again");
        }
      } catch (error) {
        toast.error("Failed to send reset link. Please verify your email.");
      } finally {
        setIsProcessing(false);
      }
    };
    reset();
  };

  const handleChange = (e) => {
    setEmail(e.target.value);
  };

  return (
    <div
      className="h-screen w-screen poppins-regular "
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="bg-white bg-opacity-50 h-full w-full flex flex-col items-center justify-center">
        <div className="bg-white rounded-2xl shadow-xl p-8 w-[400px] border border-gray-100">
          <div className="flex flex-col items-center gap-6">
            <div className="flex flex-col items-center gap-4">
              <div className="title-header">{appName}</div>
              <div className="text-[#363062] text-lg font-semibold">
                Reset Password
              </div>
              <div className="text-gray-500 text-sm text-center">
                Enter your email address and we will send you a link to reset
                your password.
              </div>
            </div>

            <div className="w-full">
              <form className="w-full space-y-4" onSubmit={handleResetPassword}>
                <div className="relative">
                  <div className="absolute top-10 left-0 pl-3 flex items-center pointer-events-none">
                    <FaEnvelope className="text-[#8FCD00] h-5 w-5" />
                  </div>
                  <InputBox
                    label="Email Address"
                    type="email"
                    placeholder="Enter your email address"
                    onChange={handleChange}
                    name="email"
                    className="pl-10"
                  />
                </div>

                <button
                  className={`w-full py-3 px-4 rounded-lg text-white font-medium transition-colors ${
                    isProcessing
                      ? "bg-gray-400 cursor-not-allowed"
                      : "bg-[#363062] hover:bg-[#2a2450]"
                  }`}
                  type="submit"
                  disabled={isProcessing}
                >
                  {isProcessing ? "Sending..." : "Send Reset Link"}
                </button>

                <Link
                  to="/login"
                  className="text-[#8FCD00] text-sm hover:text-[#363062] flex items-center justify-center gap-1 mt-4"
                >
                  <FaArrowLeft className="h-3 w-3" />
                  Back to Login
                </Link>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ResetPassword;
